export const GET_LOST = "GET_LOST";
export const ADD_LOST = "ADD_LOST";
//export const EDIT_LOST = 'EDIT_LOST';
export const DELETE_LOST = "DELETE_LOST";
export const RESOLVE_LOST = "DELETE_LOST";

export const GET_FOUND = "GET_FOUND";
export const ADD_FOUND = "ADD_FOUND";
//export const EDIT_FOUND = 'EDIT_FOUND';
export const DELETE_FOUND = "DELETE_FOUND";

export const GET_CLAIMS = "GET_CLAIMS";
export const CLAIM = "CLAIM";
export const UNCLAIM = "UNCLAIM";

export const GET_LOST_HISTORY = "GET_LOST_HISTORY";
export const GET_FOUND_HISTORY = "GET_FOUND_HISTORY";

export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

export const ADD_MESSAGE = "ADD_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const TOGGLE_LOST_MODAL = "TOGGLE_LOST_MODAL";
export const TOGGLE_FOUND_MODAL = "TOGGLE_FOUND_MODAL";

export const GET_USERS = "GET_USERS";
